import { useAuth } from "@/components/auth/auth-context.tsx";
import {
  getImpersonatorEmail,
  isImpersonatedSession,
} from "@/lib/impersonation";
import { formatDistanceToNowStrict } from "date-fns";
import { Eye } from "lucide-react";

export function ImpersonationBanner() {
  const { session, user, revokeSession } = useAuth();

  if (!isImpersonatedSession(session)) return null;

  const impersonatorEmail = getImpersonatorEmail(session);
  const expiresAt = session?.expires_at ? new Date(session.expires_at) : null;

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-400 px-4 py-2 text-center text-sm font-medium text-amber-950">
      <Eye className="h-4 w-4 shrink-0" />
      <span>
        Impersonating <strong>{user?.name ?? "…"}</strong>
        {impersonatorEmail && <> as {impersonatorEmail}</>}
      </span>
      {expiresAt && (
        <span className="text-amber-900">
          Session expires in {formatDistanceToNowStrict(expiresAt)} and cannot
          be extended.
        </span>
      )}
      <button
        className="underline underline-offset-2"
        onClick={() => {
          void revokeSession().finally(() => window.location.replace("/login"));
        }}
      >
        End session
      </button>
    </div>
  );
}
